import { useEffect } from "react";

const CANONICAL_ORIGIN = "https://pickemsports.club";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(path) {
  const href = CANONICAL_ORIGIN + (path || "");
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * usePageMeta — set per-route <title>, meta description, canonical link,
 * and OpenGraph/Twitter tags. Cleans up on unmount so a route swap doesn't
 * leak stale tags into the next route.
 *
 * @param {{ title: string, description?: string, path?: string, ogImage?: string, noindex?: boolean }} meta
 */
export default function usePageMeta({ title, description, path, ogImage, noindex = false }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", CANONICAL_ORIGIN + (path || ""), "property");
    if (ogImage) setMeta("og:image", ogImage, "property");
    setMeta("twitter:card", ogImage ? "summary_large_image" : "summary");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    if (ogImage) setMeta("twitter:image", ogImage);
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    setCanonical(path);
    return () => {
      document.title = prevTitle;
    };
  }, [title, description, path, ogImage, noindex]);
}
